/// <amd-module name="DistributedTaskUI/Logs/LogLine" />
import * as React from "react";

import { ILogLine, LogType } from "DistributedTaskUI/Logs/Logs.Types";
import { LogsViewUtility } from "DistributedTaskUI/Logs/LogsViewUtility";

import { Link } from "VSSUI/Link";
import { css } from "VSSUI/Util";

import "VSS/LoaderPlugins/Css!DistributedTaskUI/Logs/LogLine";

export interface ILogLineProps {
    logLine: ILogLine;
    showSectionIcons?: boolean;
    onNavigateToLog?: (lineNumber?: number) => void;
}

const LogsViewUtility2 = LogsViewUtility; // This is for decreasing size of the minified script

export class LogLine extends React.Component<ILogLineProps, {}> {

    public render(): React.ReactNode {
        const logLine = this.props.logLine;
        if (logLine) {
            if (logLine.lineNumber) {
                return (<Link className="log-line-link" dataIsFocusable={true} onClick={this._onLogLineClick} rel={"noopener noreferrer"} >
                    {this._getLogLineElement(logLine)}
                </Link>
                );
            }
            else {
                return this._getLogLineElement(logLine);
            }
        } else {
            return null;
        }
    }

    private _onLogLineClick = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>)  => {         
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        if (!this.props.logLine.lineNumber) {
            return;
        }
        else if (this.props.onNavigateToLog) {
            this.props.onNavigateToLog(this.props.logLine.lineNumber);
        }
    }

    private _getLogLineElement(logLine: ILogLine): JSX.Element {
        return (<div className={css("log-line-container", "flex", this._getLogLineClass(logLine.logType))} onClick={this._onLogLineClick} >
            {this.props.showSectionIcons && <div className={css("log-content-icon", "bowtie-icon", LogsViewUtility2.getLogSectionIcon(logLine.logType))} />}
            <div className="log-content-container">{this._getLogLines(logLine)}</div>
        </div>);
    }

    private _getLogLines(logLine: ILogLine): (React.ReactNode[] | null) {
        const content = logLine.content;
        if (content) {
            const lines = LogsViewUtility2.splitLogLine(content);
            return (
                lines.map((line, index) => {
                    return <div className="line-content" key={index}>{line}</div>;
                })
            );
        } else {
            return [<div className="line-content" key={"empty-line"}>{"\r\n"}</div>];
        }
    }

    private _getLogLineClass(logType?: LogType): string {
        if (!logType) {
            logType = LogType.Default;
        }
        return "logs-console-line-" + logType;
    }
}
